import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isEditResourcesListingConfigurationRequestFailure({ uuid }) {
      const req = getState().find(({ planzone }) => planzone.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isEditResourcesListingConfigurationRequestPending({ uuid }) {
      const req = getState().find(({ planzone }) => planzone.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isEditResourcesListingConfigurationRequestSuccess({ uuid }) {
      const req = getState().find(({ planzone }) => planzone.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
